<footer class="pb-0">
    <div class="container-fluid qckLinkBlock">
        <div class="container">
            <div class="row">
                <div class="col-8 col-sm-6 col-md-4 qckLink">
                    <h3>About Saas Temp</h3>
                    <p>Aliquam fermentum tellus vitae nisl dictum vel sodales diam molestie. Pellentesque nec orci posuere, feugiat quam sed.</p>
                    <p>Nam tincidunt lectus quis nibh ultrices, vitae congue risus porta mauris eros.</p>
                </div>
                <div class="col-4 col-sm-6 col-md-3 qckLink">
                    <h3>Quick Link</h3>
                    <ul>
                        <li><a href="">Career</a></li>
                        <li><a href="">Testimonail</a></li>
                        <li><a href="">Support</a></li>
                        <li><a href="">Pricing</a></li>
                        <li><a href="">About App</a></li>
                    </ul>
                </div>
                <div class="col-12 col-sm-12 col-md-5 qckLink">
                    <h3>Subscribe Our Newsletter</h3>
                    <div class="SubscribeButton">
                        <input type="email" class="form-control inputField" placeholder="Email">
                        <a href="" class="commButton mt-3 subBtn">SUBSCRIBE <img src="assets/images/send.svg"></a>
                    </div>
                    <ul class="socialMedia">
                        <li><a href=""><img src="assets/images/fb.svg" class="dsksocial" /><img src="assets/images/mb-fb.svg" class="mblsocial" /></a></li>
                        <li><a href=""><img src="assets/images/twit.svg" class="dsksocial" /><img src="assets/images/mb-twit.svg" class="mblsocial" /></a></li>
                        <li><a href=""><img src="assets/images/in.svg" class="dsksocial" /><img src="assets/images/mb-in.svg" class="mblsocial" /></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid footerMenu">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <a href="" class="footerLogo"></a>
                    <ul class="footerMenuList">
                        <li><a class="nav-link" (click)="goToSection('divHome')">Home</a></li>
                        <li><a class="nav-link" (click)="goToSection('divWhyUs')">Why Us</a></li>
                        <li><a class="nav-link" (click)="goToSection('divTestimonials')">Testimonials</a></li>
                        <li><a class="nav-link" (click)="goToSection('divPricing')">Pricing</a></li>
                        <li><a class="nav-link" (click)="goToSection('divFaq')">FAQ</a></li>
                        <li><a class="nav-link" (click)="goToSection('divContactUs')">Contact Us</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>